import { useHistory } from "react-router-dom";
import { useRef, useState } from "react";
import { AxiosResponse } from "axios";
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfProductGroup } from '../../database/index';

import { useAuth } from "src/contexts/auth";
import api from '../../services/api';

export const useFormCreateProductGroup = () => {
  const { userAgencyId } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [ProductGroupResponse, setProductGroupResponse] = useState<AxiosResponse | null>(null);
  const [ProductGroupEditedResponse, setProductGroupEditedResponse] = useState<AxiosResponse | null>(null);
  const history = useHistory();

  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    DESCRICAO: Yup.string().required('* Campo obrigatório')
  });

  const saveProductGroup = async (ProductGroup: ModelOfProductGroup) => {
    setLoading(true);

    const newProductGroup: ModelOfProductGroup = {
      ...ProductGroup,
      ORGAO: userAgencyId
    }

    if (!!ProductGroupResponse) {
      api.put(`groups/${ProductGroupResponse.data.ID}`, newProductGroup)
        .then((response) => {
          formik.resetForm();
          setProductGroupEditedResponse(response);
          setProductGroupResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'O grupo foi editada com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        })
    } else {
      api.post('groups', newProductGroup)
        .then((response) => {
          if (window.location.href === '/ProductGroupForm') history.push('/listProductGroups')
          setLoading(false);
          setProductGroupResponse(response);
          setProductGroupEditedResponse(null);
          toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Operação realizada com sucesso!', life: 5000 });
        }).catch((err) => {
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        });
    }
  }

  const formik = useFormik<ModelOfProductGroup>({
    initialValues: {
      ORGAO: '',
      DESCRICAO: '',
    },
    onSubmit: async values => await saveProductGroup(values),
    validationSchema
  });

  return {
    getProductGroupFormController: {
      formik,
      loading,
      toast,
      ProductGroupResponse,
      ProductGroupEditedResponse
    },
    handleProductGroupFormController: {
      setProductGroupResponse
    }
  };
};
